import { Portal } from '@angular/cdk/portal';
import { Injectable, signal } from '@angular/core';
import { OuiSlidePanelService } from 'omnium-ui/layout';
import { BehaviorSubject, Observable, filter, map, tap } from 'rxjs';
import { StorageFile } from '../../public-api';
import { DocumentViewerOpenOptions } from './document-viewer-panel.service';

@Injectable({ providedIn: 'root' })
export class QpiViewerPanelService {
  public fileMetadataSubject = new BehaviorSubject<StorageFile | null>(null);
  public readonly showSendToSignature = signal<boolean>(true);

  public readonly viewerClosed$: Observable<void>;

  private opened: boolean = false;

  private documentViewerPortal: Portal<any> | null = null;

  constructor(private slidePanelService: OuiSlidePanelService) {
    this.viewerClosed$ = this.slidePanelService.slidePanelState$.pipe(
      filter(state => state === 'closed' && this.opened),
      tap(() => this.onPanelClose()),
      map(() => {})
    );
  }

  public registerPortal(portal: Portal<any>) {
    this.documentViewerPortal = portal;
  }

  public openQPIDocumentViewer(fileMetadata: StorageFile, options: DocumentViewerOpenOptions = {}) {
    if (!this.documentViewerPortal) {
      throw new Error(`No portal registered in document viewer service. Please register a portal using registerPortal.`);
    }
    this.showSendToSignature.set(options.showSendToSignature ?? true);
    this.fileMetadataSubject.next(fileMetadata);
    this.slidePanelService.setSlidePanelContent(this.documentViewerPortal);
    this.slidePanelService.openSlidePanel({ position: 'right', autoFocus: false, disableClose: false });

    this.opened = true;
  }

  public closeDocumentViewer() {
    this.slidePanelService.setSlidePanelContent(null);
    this.slidePanelService.closeSlidePanel();
  }

  private onPanelClose() {
    this.opened = false;
    this.fileMetadataSubject.next(null);
  }
}
